import React, { useState } from 'react';
import { Table, Checkbox, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import SmilesComponent from './SmilesComponent';
import './MolecularForm.css';

const MolecularForm = ({ jsonData }) => {
  // 为每条数据添加唯一的 'key'
  const jsonDataWithKeys = jsonData.map((item, index) => ({ ...item, key: index }));

  const [selectedColumns, setSelectedColumns] = useState({
    smile: true,
    molwt: true,
    tpsa: true,
    slogp: true,
    sa: true,
    qed: true,
    link: true
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const toggleColumn = (key) => {
    setSelectedColumns({ ...selectedColumns, [key]: !selectedColumns[key] });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    }
  };

  const downloadCSV = (data) => {
    const csvContent = "data:text/csv;charset=utf-8," + data.map(e => Object.values(e).join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadAll = () => {
    downloadCSV(jsonDataWithKeys);
  };

  const handleDownloadSelected = () => {
    const selectedData = jsonDataWithKeys.filter(item => selectedRowKeys.includes(item.key));
    downloadCSV(selectedData);
  };

  const columns = [
    {
      title: <Checkbox checked={selectedColumns.smile} onChange={() => toggleColumn('smile')}>SMILE</Checkbox>,
      dataIndex: 'smile',
      render: (text) => <SmilesComponent smiles={text} />,
      visible: selectedColumns.smile
    },
    {
      title: <Checkbox checked={selectedColumns.molwt} onChange={() => toggleColumn('molwt')}>MolWt</Checkbox>,
      dataIndex: 'molwt',
      sorter: (a, b) => a.molwt - b.molwt,
      render: (value) => value.toFixed(2),
      visible: selectedColumns.molwt
    },
    {
      title: <Checkbox checked={selectedColumns.tpsa} onChange={() => toggleColumn('tpsa')}>TPSA</Checkbox>,
      dataIndex: 'tpsa',
      sorter: (a, b) => a.tpsa - b.tpsa,
      render: (value) => value.toFixed(2),
      visible: selectedColumns.tpsa
    },
    {
      title: <Checkbox checked={selectedColumns.slogp} onChange={() => toggleColumn('slogp')}>SLogP</Checkbox>,
      dataIndex: 'slogp',
      sorter: (a, b) => a.slogp - b.slogp,
      render: (value) => value.toFixed(2),
      visible: selectedColumns.slogp
    },
    {
      title: <Checkbox checked={selectedColumns.sa} onChange={() => toggleColumn('sa')}>SA</Checkbox>,
      dataIndex: 'sa',
      sorter: (a, b) => a.sa - b.sa,
      render: (value) => value.toFixed(2),
      visible: selectedColumns.sa
    },
    {
      title: <Checkbox checked={selectedColumns.qed} onChange={() => toggleColumn('qed')}>QED</Checkbox>,
      dataIndex: 'qed',
      sorter: (a, b) => a.qed - b.qed,
      render: (value) => value.toFixed(2),
      visible: selectedColumns.qed
    }
  ];

  return (
    <div>
      <Table
        dataSource={jsonDataWithKeys}
        columns={columns.filter(column => column.visible)}
        rowKey="key"  // 使用生成的唯一 'key'
        pagination={{ pageSize: 10 }}
        rowSelection={rowSelection}
      />
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={handleDownloadAll}
          style={{ marginRight: 8 }}
        >
          Download All
        </Button>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={handleDownloadSelected}
        >
          Download Selected
        </Button>
      </div>
    </div>
  );
};

export default MolecularForm;
